/**
 * Created by lari on 07/06/2017.
 */
(function () {
  'use strict';
  
  /* @ngdoc object
   * @name utils.sprhelp
   * @description
   *
   */
  angular
    .module('vcutils.vcfields', [
      'ui.router',
      'ui.bootstrap'
    ]);
}());